<template>
  <div>
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="title" :show-close="false" width="700px" @close="cancel">
      <el-form label-position="left" label-width="70px" :model="modifyCharge" :inline="true">
        <el-form-item :label="$t('Billing.billingCharge_chargeItem')">
          <cargo-advance-select
            filterable
            no="1"
            :select-type="selectTypeNames.basic_data_ChargeItem"
            :default-value="modifyCharge.chargeChargeItemId"
            callback-method-type="value"
            style="width:150px;"
            :disabled="!isEditing || operateType === 2"
            tag-name="zhName"
            @parentCallBack="value=>modifyCharge.chargeChargeItemId=Number(value)"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.AuditDate')">
          <el-date-picker
            v-model="modifyCharge.chargeAuditDate"
            no="2"
            :placeholder="$t('Message.SelectDate')"
            type="date"
            value-format="yyyy-MM-dd"
            :default-value="modifyCharge.chargeAuditDate"
          />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingJob_settleAccountsTo')">
          <cargo-advance-select
            filterable
            no="3"
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            :default-value="modifyCharge.chargeAccountId"
            tag-name="chineseName"
            style="width:300px;"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContactPerson')">
          <cargo-advance-select
            no="4"
            :select-type="selectTypeNames.static_data_Contact"
            style="width:130px;"
            filterable
            :cache="false"
            :disabled="!isEditing || operateType === 2"
            :default-value="modifyCharge.chargeContactPerson"
            :static-options="contactArray"
            @parentCallBack="item=>modifyCharge.chargeContactPerson=item.value"
          />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingCharge_currency')">
          <cargo-advance-select
            filterable
            no="5"
            :clearable="false"
            :select-type="selectTypeNames.basic_data_Currency"
            :default-value="modifyCharge.chargeCurrency"
            style="width:175px;"
            :disabled="!isEditing || operateType === 2"
            @parentCallBack="item=>{modifyCharge.chargeCurrency=item.value;amountChangeHandler()}"
          />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingCharge_taxExcludedPrice')">
          <el-input-number v-model="modifyCharge.chargeExcludingTaxAmount" no="6" :controls="false" :min="0" style="width: 100px" :disabled="!isEditing || operateType === 2" @change="excludingTaxAmountChangeHandler" />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingCharge_taxIncludedPrice')">
          <el-input-number v-model="modifyCharge.chargeAmount" no="7" :controls="false" :min="0" style="width: 100px" :disabled="!isEditing || operateType === 2" @change="amountChangeHandler()" />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingCharge_taxAmount')">
          <el-input-number v-model="modifyCharge.chargeTaxAmount" no="8" :controls="false" style="width: 80px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TaxRate')">
          <el-input-number v-model="modifyCharge.chargeTaxRate" no="9" :controls="false" style="width: 80px" :disabled="!isEditing || operateType === 2" @change="excludingTaxAmountChangeHandler" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Quantity2')">
          <el-input-number v-model="modifyCharge.chargeQuantity" no="chargeQuantity" :precision="3" :controls="false" style="width: 80px" :disabled="!isEditing || operateType === 2" @change="quantityChangeHandler" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.UnitRate')">
          <el-input-number v-model="modifyCharge.chargeUnitRate" no="chargeUnitRate" :precision="3" :controls="false" style="width: 80px" :disabled="!isEditing || operateType === 2" @change="unitRateChangeHandler" />
        </el-form-item>
        <el-form-item :label="$t('Billing.billingCharge_remarks')">
          <el-input v-model="chargeRemarks" no="10" type="textarea" :rows="5" style="width: 500px" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" no="11" size="mini" @click="saveEvent">{{ $t('common.btn.save') }}</el-button>
        <el-button no="12" size="mini" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getContacts } from '@/api/partner/contact'
import DateUtils from '@/utils/dateUtils'
import { getUuid } from '@/utils'
import lodash from 'lodash'
import {
  CHARGE_SOURCE_RED_FLUSH
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ChargeAdjustmentDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true } // 弹框打开时默认传递条件
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: this.visible,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      title: '',
      modifyCharge: {}, // 更新后的费用
      originCharge: {}, // 更新前的原始费用
      isEditing: false,
      contactArray: [],
      justCharges: [],
      operateType: 0,
      chargeRemarks: ''
    }
  },
  computed: {},
  created() {
  },
  beforeMount() {
    const defaultProperties = this.defaultProperties
    if (defaultProperties) {
      const operateType = defaultProperties['operateType']
      if (operateType !== undefined) {
        this.operateType = operateType
        if (BillingNativeUtils.ADD_JUST === operateType) {
          this.title = this.$t('CargoMsg.Cargo_IncreaseAdjustment')
        } else if (BillingNativeUtils.EDIT_JUST === operateType) {
          this.title = this.$t('CargoMsg.Cargo_EditAdjustment')
        } else if (BillingNativeUtils.DEL_JUST === operateType) {
          this.title = this.$t('CargoMsg.Cargo_DeleteAdjustment')
        }
      }
      if (defaultProperties['modifyCharge']) {
        this.originCharge = lodash.cloneDeep(defaultProperties['modifyCharge'])
      }
      const modifyCharge = defaultProperties['modifyCharge']
      if (modifyCharge) {
        modifyCharge['chargeChargeItemId'] = operateType > BillingNativeUtils.ADD_JUST ? modifyCharge['chargeChargeItemId'] : ''
        modifyCharge['chargeExcludingTaxAmount'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeExcludingTaxAmount'], 2) : 0.00
        modifyCharge['chargeAmount'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeAmount'], 2) : 0.00
        modifyCharge['chargeTaxRate'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeTaxRate'], 2) : 0.00
        modifyCharge['chargeTaxAmount'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeTaxAmount'], 2) : 0.00
        modifyCharge['chargeAuditDate'] = new Date()
        modifyCharge['chargeQuantity'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeQuantity'], 3) : 0.000
        modifyCharge['chargeUnitRate'] = operateType > BillingNativeUtils.ADD_JUST ? NumberUtils.roundHalfUp(modifyCharge['chargeUnitRate'], 3) : 0.000
        this.modifyCharge = modifyCharge
        if (modifyCharge['chargeAccountId']) {
          this.loadContacts(modifyCharge['chargeAccountId'])
        }
      }
      const isEditing = defaultProperties['isEditing']
      if (isEditing !== undefined) {
        this.isEditing = isEditing
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    async saveEvent() {
      const passThrough = this.validateCharge()
      if (passThrough) {
        const modifyCharge = this.modifyCharge
        const operateType = this.defaultProperties.operateType
        const justCharges = this.justCharges
        switch (operateType) {
          case 0:
          {
            justCharges.push({ 'mode': 0, 'charge': await this.createCharge() })
            break
          }
          case 1:
          {
            if (modifyCharge['chargeChargeState'] === 2) {
              justCharges.push({ 'mode': 1, 'charge': await this.delHedgeCharge() })
              justCharges.push({ 'mode': 2, 'charge': await this.createHedgeCharge() })
              justCharges.push({ 'mode': 3, 'charge': this.originCharge })
            } else {
              await this.editCharge()
              justCharges.push({ 'mode': 3, 'charge': modifyCharge })
            }
            break
          }
          case 2:
          {
            justCharges.push({ 'mode': 1, 'charge': await this.delHedgeCharge() })
            modifyCharge['dirty'] = true
            modifyCharge['chargeOffsetState'] = 1
            justCharges.push({ 'mode': 3, 'charge': modifyCharge })
            break
          }
          default:
          {
            break
          }
        }
        this.$emit('chargeAdjustmentCallBackEvent', justCharges)
      }
    },
    async createCharge() { // 增加费用
      const modifyCharge = this.modifyCharge
      const item = {}
      item['entity'] = 'charge'
      item['chargeUid'] = getUuid() // 作为唯一标识
      item['uuid'] = null
      item['version'] = 0
      item['jobUuid'] = modifyCharge['jobUuid']
      item['jobJobNo'] = modifyCharge['jobJobNo']
      item['jobJobState'] = modifyCharge['jobJobState']
      item['jobMbl'] = modifyCharge['jobMbl']
      item['jobVesselFlight'] = modifyCharge['jobVesselFlight']
      item['jobAr'] = modifyCharge['chargeReceivable']
      item['jobChargeCurrency'] = modifyCharge['chargeCurrency']
      item['jobConfirmState'] = modifyCharge['chargeConfirmState']
      item['jobBillingAmount'] = modifyCharge['chargeBillingAmount']
      item['jobChargeAmountTotal'] = modifyCharge['chargeAmount']
      item['jobDifferenceAmount'] = modifyCharge['jobDifferenceAmount']
      item['jobBookingAgent'] = modifyCharge['jobBookingAgent']
      item['jobCarrierId'] = modifyCharge['jobCarrierId']
      item['jobCustomerId'] = modifyCharge['jobCustomerId']
      item['jobDischargingPortCode'] = modifyCharge['jobDischargingPortCode']
      item['jobEtd'] = modifyCharge['jobEtd']
      item['jobLob'] = modifyCharge['jobLob']
      item['jobOp'] = modifyCharge['jobOp']
      item['jobSales'] = modifyCharge['jobSales']
      item['originUuid'] = modifyCharge['uuid']
      item['billingUuid'] = modifyCharge['billingUuid']
      item['billingNo'] = modifyCharge['billingNo']
      item['chargeAccountId'] = modifyCharge['chargeAccountId']
      item['chargeContactPerson'] = modifyCharge['chargeContactPerson']
      item['chargeOversea'] = modifyCharge['chargeOversea']
      item['chargeReceivable'] = modifyCharge['chargeReceivable']
      item['chargeChargeItemId'] = modifyCharge['chargeChargeItemId']
      item['chargeCurrency'] = modifyCharge['chargeCurrency']
      item['chargeVerifiedAmount'] = 0
      item['chargeInvoiceAmount'] = 0
      item['chargeInvoiceExcludingTax'] = 0
      item['chargeInvoiceTax'] = 0
      item['chargeBillingAmount'] = 0
      item['chargeAuditDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeAccountingDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeBranchId'] = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      item['chargeExchangeRate'] = await RateUtil.getForeignExchangeRateSafely(localCurrency, modifyCharge['chargeCurrency'], modifyCharge['chargeAuditDate'], item['chargeBranchId'])
      item['chargeInputBy'] = this.$store.getters.userId
      item['chargeChargeState'] = modifyCharge['jobJobState']
      item['chargeAdvance'] = modifyCharge['chargeAdvance']
      item['chargeCommission'] = modifyCharge['chargeCommission']
      item['chargeAdjustment'] = true
      item['chargeConfirmState'] = 0
      item['chargeDifferentState'] = 0
      item['chargeOffsetState'] = 0
      item['chargePrepaid'] = modifyCharge['chargePrepaid']
      item['chargeContainerNo'] = modifyCharge['chargeContainerNo']
      item['chargeMeasure'] = modifyCharge['chargeMeasure']
      item['chargeQuantity'] = NumberUtils.roundHalfUp(modifyCharge['chargeQuantity'], 3)
      item['chargeRelatedId'] = modifyCharge['chargeChargeId']
      item['chargeSource'] = CHARGE_SOURCE_RED_FLUSH.code
      item['chargeTaxRate'] = NumberUtils.roundHalfUp(modifyCharge['chargeTaxRate'])
      item['chargeAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeAmount'])
      item['chargeTaxAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeTaxAmount'])
      item['chargeExcludingTaxAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeExcludingTaxAmount'])
      item['chargeUnitRate'] = NumberUtils.roundHalfUp(modifyCharge['chargeUnitRate'], 3)
      item['chargeRemarks'] = modifyCharge['chargeRemarks']
      item['jobImportHbl'] = modifyCharge['jobImportHbl']
      item['jobSoNo'] = modifyCharge['jobSoNo']
      item['chargeBusinessDate'] = modifyCharge['chargeBusinessDate']
      return item
    },
    async createHedgeCharge() { // 生成对冲费用
      const modifyCharge = this.modifyCharge
      const item = {}
      item['entity'] = 'charge'
      item['chargeUid'] = getUuid() // 作为唯一标识
      item['uuid'] = null
      item['version'] = 0
      item['jobUuid'] = modifyCharge['jobUuid']
      item['jobJobNo'] = modifyCharge['jobJobNo']
      item['jobJobState'] = modifyCharge['jobJobState']
      item['jobMbl'] = modifyCharge['jobMbl']
      item['jobVesselFlight'] = modifyCharge['jobVesselFlight']
      item['jobAr'] = modifyCharge['chargeReceivable']
      item['jobChargeCurrency'] = modifyCharge['chargeCurrency']
      item['jobConfirmState'] = modifyCharge['chargeConfirmState']
      item['jobBillingAmount'] = modifyCharge['chargeBillingAmount']
      item['jobChargeAmountTotal'] = modifyCharge['chargeAmount']
      item['jobDifferenceAmount'] = modifyCharge['jobDifferenceAmount']
      item['jobBookingAgent'] = modifyCharge['jobBookingAgent']
      item['jobCarrierId'] = modifyCharge['jobCarrierId']
      item['jobCustomerId'] = modifyCharge['jobCustomerId']
      item['jobDischargingPortCode'] = modifyCharge['jobDischargingPortCode']
      item['jobEtd'] = modifyCharge['jobEtd']
      item['jobLob'] = modifyCharge['jobLob']
      item['jobOp'] = modifyCharge['jobOp']
      item['jobSales'] = modifyCharge['jobSales']
      item['originUuid'] = modifyCharge['uuid']
      item['billingUuid'] = modifyCharge['billingUuid']
      item['billingNo'] = modifyCharge['billingNo']
      item['chargeAccountId'] = modifyCharge['chargeAccountId']
      item['chargeContactPerson'] = modifyCharge['chargeContactPerson']
      item['chargeOversea'] = modifyCharge['chargeOversea']
      item['chargeReceivable'] = modifyCharge['chargeReceivable']
      item['chargeChargeItemId'] = modifyCharge['chargeChargeItemId']
      item['chargeCurrency'] = modifyCharge['chargeCurrency']
      item['chargeTaxRate'] = NumberUtils.roundHalfUp(modifyCharge['chargeTaxRate'])
      item['chargeAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeAmount'])
      item['chargeTaxAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeTaxAmount'])
      item['chargeExcludingTaxAmount'] = NumberUtils.roundHalfUp(modifyCharge['chargeExcludingTaxAmount'])
      item['chargeVerifiedAmount'] = 0
      item['chargeInvoiceAmount'] = 0
      item['chargeInvoiceExcludingTax'] = 0
      item['chargeBillingAmount'] = 0
      item['chargeInvoiceTax'] = 0
      item['chargeMeasure'] = modifyCharge['chargeMeasure']
      item['chargeQuantity'] = NumberUtils.roundHalfUp(modifyCharge['chargeQuantity'], 3)
      item['chargeUnitRate'] = NumberUtils.roundHalfUp(modifyCharge['chargeUnitRate'], 3)
      item['chargeAuditDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeAdvance'] = modifyCharge['chargeAdvance']
      item['chargeCommission'] = modifyCharge['chargeCommission']
      item['chargeAdjustment'] = true
      item['chargeChargeState'] = modifyCharge['jobJobState']
      item['chargeConfirmState'] = 0
      item['chargeDifferentState'] = 0
      item['chargeOffsetState'] = 0
      item['chargeRelatedId'] = modifyCharge['chargeChargeId']
      item['chargeSource'] = CHARGE_SOURCE_RED_FLUSH.code
      item['chargePrepaid'] = modifyCharge['chargePrepaid']
      item['chargeContainerNo'] = modifyCharge['chargeContainerNo']
      item['chargeAccountingDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeBranchId'] = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      item['chargeExchangeRate'] = await RateUtil.getForeignExchangeRateSafely(localCurrency, item['chargeCurrency'], item['chargeAccountingDate'], item['chargeBranchId'])
      item['chargeInputBy'] = this.$store.getters.userId
      item['chargeRemarks'] = this.chargeRemarks
      item['jobImportHbl'] = modifyCharge['jobImportHbl']
      item['jobSoNo'] = modifyCharge['jobSoNo']
      item['chargeBusinessDate'] = modifyCharge['chargeBusinessDate']
      return item
    },
    async delHedgeCharge() { // 删除 对冲费用
      const originCharge = this.originCharge
      const modifyCharge = this.modifyCharge
      const item = {}
      item['entity'] = 'charge'
      item['chargeUid'] = getUuid() // 作为唯一标识
      item['uuid'] = null
      item['version'] = 0
      item['originUuid'] = originCharge['uuid']
      item['jobUuid'] = originCharge['jobUuid']
      item['jobJobNo'] = originCharge['jobJobNo']
      item['jobJobState'] = originCharge['jobJobState']
      item['jobMbl'] = originCharge['jobMbl']
      item['jobVesselFlight'] = originCharge['jobVesselFlight']
      item['jobAr'] = originCharge['chargeReceivable']
      item['jobChargeCurrency'] = originCharge['chargeCurrency']
      item['jobConfirmState'] = originCharge['chargeConfirmState']
      item['jobBillingAmount'] = originCharge['chargeBillingAmount']
      item['jobChargeAmountTotal'] = originCharge['chargeAmount']
      item['jobDifferenceAmount'] = originCharge['jobDifferenceAmount']
      item['jobBookingAgent'] = originCharge['jobBookingAgent']
      item['jobCarrierId'] = originCharge['jobCarrierId']
      item['jobCustomerId'] = originCharge['jobCustomerId']
      item['jobDischargingPortCode'] = originCharge['jobDischargingPortCode']
      item['jobEtd'] = originCharge['jobEtd']
      item['jobLob'] = originCharge['jobLob']
      item['jobOp'] = originCharge['jobOp']
      item['jobSales'] = originCharge['jobSales']
      item['billingUuid'] = originCharge['billingUuid']
      item['billingNo'] = originCharge['billingNo']
      item['chargeChargeItemId'] = originCharge['chargeChargeItemId']
      item['chargeReceivable'] = originCharge['chargeReceivable']
      item['chargeOversea'] = originCharge['chargeOversea']
      item['chargeShared'] = originCharge['chargeShared']
      item['chargeShareRefNo'] = originCharge['chargeShareRefNo']
      item['chargeCommission'] = originCharge['chargeCommission']
      item['chargeAdvance'] = originCharge['chargeAdvance']
      item['chargePrepaid'] = originCharge['chargePrepaid']
      item['chargeAccountId'] = originCharge['chargeAccountId']
      item['chargeCurrency'] = originCharge['chargeCurrency']
      item['chargeMeasure'] = originCharge['chargeMeasure']
      item['chargeQuantity'] = NumberUtils.roundHalfUp(originCharge['chargeQuantity'], 3)
      item['chargeUnitRate'] = NumberUtils.roundHalfUp(-originCharge['chargeUnitRate'], 3)
      item['chargeBranchId'] = originCharge['chargeBranchId']
      item['chargeContactPerson'] = originCharge['chargeContactPerson']
      item['chargeContainerNo'] = originCharge['chargeContainerNo']
      item['chargeInputBy'] = this.$store.getters.userId
      item['chargeInputDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      item['chargeAuditor'] = this.$store.getters.userId
      item['chargeAuditDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeAccountingDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      item['chargeExchangeRate'] = originCharge['chargeExchangeRate']
      item['chargeAmount'] = -originCharge['chargeAmount']
      item['chargeTaxRate'] = originCharge['chargeTaxRate']
      item['chargeTaxAmount'] = -originCharge['chargeTaxAmount']
      item['chargeVerifiedAmount'] = 0
      item['chargeInvoiceAmount'] = 0
      item['chargeInvoiceExcludingTax'] = 0
      item['chargeInvoiceTax'] = 0
      item['chargeBillingAmount'] = 0
      item['chargeExcludingTaxAmount'] = -NumberUtils.roundHalfUp(originCharge['chargeExcludingTaxAmount'])
      item['chargeAdvance'] = originCharge['chargeAdvance']
      item['chargeCommission'] = originCharge['chargeCommission']
      item['chargeRelatedId'] = originCharge['chargeChargeId']
      item['chargeSource'] = CHARGE_SOURCE_RED_FLUSH.code
      item['chargeAdjustment'] = true
      item['chargeOffsetState'] = 2
      item['chargeChargeState'] = originCharge['jobJobState']
      item['chargeConfirmState'] = 0
      item['chargeDifferentState'] = 0
      item['chargeRemarks'] = this.chargeRemarks
      item['jobImportHbl'] = originCharge['jobImportHbl']
      item['jobSoNo'] = originCharge['jobSoNo']
      item['chargeBusinessDate'] = originCharge['chargeBusinessDate']
      return item
    },
    async editCharge() {
      const modifyCharge = this.modifyCharge
      modifyCharge['dirty'] = true
      const localCurrency = RateUtil.localCurrencyByOfficeId(modifyCharge['chargeBranchId'])
      modifyCharge['chargeExchangeRate'] = await RateUtil.getForeignExchangeRateSafely(localCurrency, modifyCharge['chargeCurrency'], modifyCharge['chargeAuditDate'], modifyCharge['chargeBranchId'])
      // modifyCharge['chargeUnitRate'] = NumberUtils.roundHalfUp(modifyCharge['chargeExcludingTaxAmount'] / modifyCharge['chargeQuantity'], 2)
      modifyCharge['chargeAccountingDate'] = DateUtils.customFormat(modifyCharge['chargeAuditDate'], 'YYYY-MM-DD')
      modifyCharge['chargeRemarks'] = this.chargeRemarks
    },
    amountChangeHandler() { // 修改含税价
      const modifyCharge = this.modifyCharge
      if (modifyCharge['chargeAdvance']) { return }
      if (!isNaN(modifyCharge['chargeAmount'])) {
        let amount = Number(modifyCharge['chargeAmount'])
        amount = RateUtil.getAmountByCurrency(amount, modifyCharge.chargeCurrency)
        modifyCharge['chargeAmount'] = amount
        const taxRate = modifyCharge['chargeTaxRate']
        // const excludingTaxAmount = amount / (1 + (taxRate / 100))
        const excludingTaxAmount = RateUtil.getAmountByCurrency(amount / (1 + (taxRate / 100)), modifyCharge.chargeCurrency)
        modifyCharge['chargeExcludingTaxAmount'] = NumberUtils.roundHalfUp(excludingTaxAmount, 2)
        // modifyCharge['chargeTaxAmount'] = NumberUtils.roundHalfUp(amount - excludingTaxAmount, 2)
        modifyCharge['chargeTaxAmount'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(amount - excludingTaxAmount, modifyCharge.chargeCurrency), 2)
        const chargeQuantity = Number(modifyCharge['chargeQuantity'])
        if (chargeQuantity !== 0) {
          modifyCharge['chargeUnitRate'] = NumberUtils.ToFixed2(excludingTaxAmount / chargeQuantity, 3)
        }
      }
    },
    excludingTaxAmountChangeHandler() { // 修改不含税金额,税率
      const modifyCharge = this.modifyCharge
      if (modifyCharge['chargeAdvance']) return
      let excludingTaxAmount = modifyCharge['chargeExcludingTaxAmount']
      if (!isNaN(excludingTaxAmount)) {
        excludingTaxAmount = RateUtil.getAmountByCurrency(excludingTaxAmount, modifyCharge.chargeCurrency)
        modifyCharge['chargeExcludingTaxAmount'] = excludingTaxAmount
        const taxRate = modifyCharge['chargeTaxRate']
        const taxAmount = excludingTaxAmount * (taxRate / 100)
        // const amount = excludingTaxAmount + taxAmount
        const amount = RateUtil.getAmountByCurrency(excludingTaxAmount + taxAmount, modifyCharge.chargeCurrency)
        modifyCharge['chargeAmount'] = NumberUtils.roundHalfUp(amount, 2)
        // modifyCharge['chargeTaxAmount'] = NumberUtils.roundHalfUp(amount - excludingTaxAmount, 2)
        modifyCharge['chargeTaxAmount'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(amount - excludingTaxAmount, modifyCharge.chargeCurrency), 2)
        const chargeQuantity = Number(modifyCharge['chargeQuantity'])
        if (chargeQuantity !== 0) {
          modifyCharge['chargeUnitRate'] = NumberUtils.ToFixed2(excludingTaxAmount / chargeQuantity, 3)
        }
      }
    },
    // 数量
    quantityChangeHandler() {
      if (this.modifyCharge['chargeAdvance']) { return }
      const quantity = parseFloat(this.modifyCharge['chargeQuantity'])
      if (!isNaN(quantity)) {
        this.modifyCharge['chargeQuantity'] = NumberUtils.ToFixed2(quantity, 3)
        this.modifyCharge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2(quantity * this.modifyCharge['chargeUnitRate'], 2)
        this.excludingTaxAmountChangeHandler()
      }
    },
    // 单价
    unitRateChangeHandler() {
      if (this.modifyCharge['chargeAdvance']) { return }
      const unitRate = parseFloat(this.modifyCharge['chargeUnitRate'])
      if (!isNaN(unitRate)) {
        this.modifyCharge['chargeUnitRate'] = NumberUtils.ToFixed2(unitRate, 3)
        this.modifyCharge['chargeExcludingTaxAmount'] = NumberUtils.ToFixed2(unitRate * this.modifyCharge['chargeQuantity'], 2)
        this.excludingTaxAmountChangeHandler()
      }
    },
    loadContacts(chargeAccountId) { // 加载结算对象所维护的联系人
      getContacts({ cmpIdx: chargeAccountId }).then(res => {
        if (res.data) {
          this.contactArray = res.data
        }
      }).catch(error => {
        console.log('getContacts error', error)
      })
    },
    validateCharge() { // 保存费用校验
      const modifyCharge = this.modifyCharge
      if (!modifyCharge['chargeAuditDate']) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AdjustmentDateCanTBeEmpty'))
        return false
      }
      if (!modifyCharge['chargeChargeItemId']) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseDescriptionCanTBeEmpty'))
        return false
      }
      if (isNaN(modifyCharge['chargeAmount']) || !modifyCharge['chargeAmount']) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IncludingTaxAmountZero'))
        return false
      }
      if (this.chargeRemarks && this.chargeRemarks.length > 256) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTheLengthCannotExceedP256'))
        return false
      }
      return true
    }
  }
}
</script>
